import React, { Component } from "react";
import { CustomDropdown } from "../../../../common/custom-form/custom-dropdown.component";
import AccountAuditRules from "../details/account-audit.rules.component";
import { AccountCostAllocation } from "../details/account-cost-allocation.component";
import AccountLocationAddress from "../details/account-location-details.componet";
import AccountLocationRemit from "../details/account-location-remit.component";
import { AccountPurchaseOrder } from "../details/account-purchase.component";

export class DetailList extends Component {
   constructor(props){
       super(props);
       this.state={
           CheckBoxValue:[
               "Fist Bill",
               "MRC Mismatch",
               "Invoice Total Mismatch",
               "Billing Start Date",
               "NRC Mismatch",
               "Invoice Percent",
               "Billing End Date",
               "Billing Account Mismatch",
               "Previous Balance",
               "High Spender",
               "Different Provider",
               "Previous Balance Percent",
               "Circuit Percent",
               "Disconnected",
               "Duplicate",
               "Order In Progress",
               "Deleted",
               "Unbilled Circuit",
               "Dispute In Process",
               "Circuit Not Found"
             ],dataTable:[
               {              
                   HeaderItem:[
                       {
                           name:"Contract Name"
                       },
                       {
                           name:"Vendor"
                       }, {
                           name:"Status"
                       }
                   ],
                   dataItem:[{            
                       columnItem1:"3G Hutchison (GB) Contract",
                       columnItem2: "3G Hutchison (GB)",
                       columnItem3: "Expired"                       
                   }, {            
                       columnItem1:"3G Hutchison (GB) Contract",
                       columnItem2: "3G Hutchison (GB)",
                       columnItem3: "Expired"
                   },{            
                       columnItem1:"3G Hutchison (GB) Contract",
                       columnItem2: "3G Hutchison (GB)",
                       columnItem3: "Expired"
                   }        
                   ]
    
               }
           ],
       }
   }
   render(){
       return(
           <>
               <CustomDropdown label="Location Billing Address">
                    <AccountLocationAddress/> 
                </CustomDropdown>

                <CustomDropdown label="Location Remit Address">
                    <AccountLocationRemit />
                </CustomDropdown>

                        <CustomDropdown label="Audit Rules">
                    <AccountAuditRules CheckBoxValue={this.state.CheckBoxValue}/>
                    </CustomDropdown>
                        

                <CustomDropdown label="Cost Allocation">
                    <AccountCostAllocation datatable={this.state.dataTable} />
                </CustomDropdown>
                <CustomDropdown label="Purchase Order">
                    <AccountPurchaseOrder datatable={this.state.dataTable}/>
                </CustomDropdown>
           </>
       )
   }
}